<template>
    <div class="mr-title__wrapper mr-hide-mobile width-full">
        <div class="cp-arrow-return__wrapper">
            <div class="cp-title-page__wrapper">
                <icon-font
                    v-if="icon"
                    class="cp-title-page__icon"
                    :size="iconSize"
                    :icon="icon"
                />

                <h1 class="cp-title-page">
                    <slot />
                </h1>
            </div>

            <div class="cp-title__actions">
                <div v-if="totalItems" class="cd-admin-table-total">
                    Всего: {{ totalItems }}
                </div>

                <slot name="actions-prepend" />

                <div v-if="isAdd" class="cp-flex" @click="toAdd">
                    <icon-font size="20" icon="add" />
                </div>

                <div class="cp-arrow-return" @click="returnBefore">
                    <arrow-return color="#9B9BC7" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import IconFont from '@/components/icons/IconFont.vue';
import ArrowReturn from '@/components/icons/ArrowReturn.vue';

export default {
    components: {
        IconFont,
        ArrowReturn,
    },
    props: {
        iconSize: {
            type: String,
        },
        icon: {
            type: String,
        },
        isAdd: {
            type: Boolean,
        },
        totalItems: {
            type: Number,
        },
    },
    methods: {
        returnBefore() {
            this.$emit('click');
        },

        toAdd() {
            this.$emit('toAdd');
        },
    },
};
</script>
